<template>
  <v-dialog
    v-model="openDialog"
    :persistent="true"
    max-width="750px">
    <div class="layerPopup">
      <div class="layerTit">
        チケットの組合わせ
        <span class="ticketId">メインチケット:<span>{{selectedTicket[0] ? selectedTicket[0].dispId : ''}}</span></span>
      </div>
      <div class="layerContent large">
        <div class="mergeTicketBox">
          <table class="UXTbl">
            <colgroup>
              <col style="width:130px;" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th>メモ</th>
                <td>
                  <v-textarea
                    hide-details
                    no-resize
                    outline
                    height="90"
                    class="UXtextarea"
                    v-model="mergeMemo"
                    placeholder="組合わせの際に追加するメモを書いてください">
                  </v-textarea>
                </td>
              </tr>
              <tr>
                <th>サブチケット</th>
                <td>
                  <div class="childTickets">
                    <p class="notChildTicket" v-if="childTickets.length === 0">
                      組合わすチケットを下のリストから選んでください。
                    </p>
                    <ul>
                      <li v-for="childTicket in childTickets" :key="childTicket.id"><span>{{childTicket.dispId}}<i class="UXicon-close" @click="popChildTicket(childTicket)"></i></span></li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <th>チケットID</th>
                <td>
                  <v-text-field
                    v-model="keyword"
                    append-icon="search"
                    placeholder="チケット ID 検索"
                    @keyup.enter="showKeywordSearchResult()"
                    class="UXinput UXicon-search"
                    hide-details
                    outline
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <th class="require-after">チケットリスト</th>
                <td>
                  <div class="mergeAbleTicketItems">
                    <div class="notTicket" v-if="mergeAbleTicketItems.length === 0">
                      チケットが存在しません。
                    </div>
                    <ul>
                      <li v-for="item in mergeAbleTicketItems" :key="item.id">
                        <p @click="clickTicketCard(item)">
                          <strong>{{item.dispId}}</strong><span>{{item.subject}}</span>
                        </p>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="cenBtn" style="padding:30px 0 20px 0;">
            <v-btn outline round large class="UXbtn widthAuto" @click="closeDialog">キャンセル</v-btn>
            <v-btn round dark large color="#ff8c8c" class="UXbtn widthAuto" @click="executeMerge">適用</v-btn>
          </div>
        </div>
      </div>
      <div class="layerClose">
        <v-btn flat icon @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import eventBus from '@/event_bus'
import event from '../../../enums/eventType'
import TicketListUtil from '../../../util/ticket_list_util'
import {mapGetters, mapMutations} from 'vuex'
import helper from 'util/helpers'
import util from '@/util'

export default {
  props: {
    mergeTicketDialog: Boolean,
    close: Function,
    selectedTicket: Array
  },
  watch: {
    mergeTicketDialog: function () {
      this.openDialog = this.mergeTicketDialog
    },
    openDialog: function (newval, oldval) {
      if (!newval && oldval) {
        this.close()
      } else {
        if (newval) {
          this.childTickets = []
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentTicketBrandId',
      'mergeSearchKeyword',
      'currentBrandId'
    ]),
    showNoResult () {
      return (this.mergeAbleTicketItems.length < 1)
    }
  },
  data: () => ({
    brandId: '',
    childTickets: [],
    mergeAbleTicketItems: [],
    openDialog: false,
    pagination: {
      page: 1
    },
    mergeMemo: '',
    isEndReached: false,
    alertFired: false,
    keyword: '',
    isNoResult: false,
    searchMode: false
  }),
  created () {
    this.initialize()
  },
  methods: {
    ...mapMutations([
      'setMergeSearchKeyword'
    ]),
    initialize () {
      if (this.currentBrandId) {
        this.brandId = this.currentBrandId
      } else {
        this.brandId = util.parseLoginToken().agentMappingBrandViews[0].brandId
      }
    },
    closeDialog () {
      this.openDialog = false
    },
    callMergeAbleTicketList () {
      if (!this.isEndReached) {
        if (this.selectedTicket[0]) {
          this.axios.get(`/gateway/ticket/merge/list`, {
            params: {
              brandId: this.currentTicketBrandId,
              page: this.pagination.page || 1,
              size: 100,
              parentTicketId: this.selectedTicket[0].id
            }
          }).then((res) => {
            if (res.data.data.length === 0) {
              this.isEndReached = true
            }
            this.pagination.page += 1
            let data = res.data.data
            let ticketList = []
            data.forEach(ticket => {
              if (this.selectedTicket[0].dispId !== ticket.dispId) {
                ticketList.push(ticket)
              }
            })
            this.mergeAbleTicketItems = this.mergeAbleTicketItems.concat(ticketList)
          })
        }
      }
    },
    searchTicketByKeyword () {
      if (!this.isEndReached) {
        if (this.selectedTicket[0]) {
          this.axios.get(`/gateway/ticket/merge/search`, {
            params: {
              brandId: this.currentTicketBrandId,
              ticketId: this.selectedTicket[0].id,
              keyword: this.mergeSearchKeyword,
              page: this.pagination.page || 1,
              size: 10
            }
          })
            .then(result => {
              if (result.data.data.length === 0) {
                this.isEndReached = true
              }
              this.pagination.page += 1
              this.mergeAbleTicketItems = this.mergeAbleTicketItems.concat(result.data.data)
              this.excludeSelectedTicket()
            })
        }
      }
    },
    clickTicketCard (data) {
      let tmp = TicketListUtil.checkItemInTicketSelectedArray(this.childTickets, data.id)
      if (tmp.result) {
        this.childTickets.splice(tmp.index, 1)
      } else {
        this.mergeAbleTicketItems.filter((f, index) => {
          if (f.id === data.id) {
            this.mergeAbleTicketItems.splice(index, 1)
          }
        })
        this.childTickets.push(data)
      }
    },
    executeMerge () {
      const parentTicketId = this.selectedTicket[0].id
      this.axios.put(`/api/brand/${this.brandId}/tickets/${parentTicketId}/merge`, {
        childTicketIds: TicketListUtil.getTicketIdsFromTicketArr(this.childTickets),
        mergeMemo: this.mergeMemo
      }).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          this.$alertMsg('組合わせに成功しました。')
          this.openDialog = false
        } else {
          if (res.data.message) {
            this.$alertMsg(res.data.message)
          } else {
            this.$alertMsg('組合わせに失敗しました。')
          }
        }
      })
    },
    onScroll (event) {
      let clientHeight = event.srcElement.clientHeight
      let scrollHeight = event.srcElement.scrollHeight
      let scrollTop = event.srcElement.scrollTop
      if (clientHeight !== 0) {
        if ((scrollTop + clientHeight) >= scrollHeight) {
          if (this.searchMode) {
            this.searchTicketByKeyword()
          } else {
            this.callMergeAbleTicketList()
          }
        }
      }
    },
    popChildTicket (data) {
      let tmp = TicketListUtil.checkItemInTicketSelectedArray(this.childTickets, data.id)
      this.childTickets.splice(tmp.index, 1)
      if (this.mergeAbleTicketItems.length > 0) {
        let isFindDateDiff = this.mergeAbleTicketItems.find((f, index) => {
          if (TicketListUtil.checkDateCompare(f.modifyDate, data.modifyDate)) {
            this.mergeAbleTicketItems.splice(index, 0, data)
            return true
          }
        })
        if (!isFindDateDiff) {
          this.mergeAbleTicketItems.push(data)
        }
      } else {
        this.mergeAbleTicketItems.push(data)
      }
    },
    showKeywordSearchResult () {
      this.mergeAbleTicketItems = []
      this.pagination.page = 1
      this.isEndReached = false
      this.setMergeSearchKeyword(this.keyword)

      if (helper.isStringValid(this.mergeSearchKeyword)) {
        // keyword가 있을 때 -> 검색 리스트 호출
        this.searchMode = true
        this.searchTicketByKeyword()
      } else {
        // keyword가 비었을 때 -> 전체 리스트 호출
        this.searchMode = false
        this.callMergeAbleTicketList()
      }
    },
    excludeSelectedTicket () {
      let selectedList = this.childTickets
      selectedList.forEach(item => {
        let index = this.mergeAbleTicketItems.findIndex(function (value) { return value.id === item.id })
        if (index > -1) this.mergeAbleTicketItems.splice(index, 1)
      })
    },
    removeBackgroundColor () {
      return this.showNoResult ? 'background-color: #ffffff' : 'background-color: #f9f9f9'
    }
  },
  mounted () {
    eventBus.$on(event.OPEN_TICKET_MERGE_DIALOG, () => {
      this.openDialog = true
      this.isEndReached = false
      this.alertFired = false
      this.childTickets = []
      this.mergeAbleTicketItems = []
      this.pagination.page = 1
      this.callMergeAbleTicketList()
      this.keyword = ''
      this.isNoResult = false
      this.searchMode = false
    })
  }
}
</script>

<style lang="scss">
  .mergeTicketBox {
    .childTickets {
      height:95px;
      border:1px solid $gray-5;
      border-radius: 3px;
      overflow-y: auto;
      p {
        margin:0;
        padding:8px 10px;
        color: $gray-6;
      }
      ul {
        padding:8px 10px;
        li {
          padding: 0 5px 5px 0;
          list-style: none;
          display: inline-flex;
          justify-content: flex-start;
          align-items: center;
          span {
            padding:0 10px;
            display:inline-block;
            height:35px;
            line-height:35px;
            font-size: 14px;
            color: $gray-8;
            background: $gray-2;
            border-radius: 3px;
            transition: background .28s cubic-bezier(.4,0,.2,1);
            i {
              cursor: pointer;
              position: relative;
              left: 3px;
              font-size: 12px;
            }
          }
          &:hover {
            span {
              background: $gray-3;
            }
          }
        }
      }
    }
    .mergeAbleTicketItems {
      padding:12px 8px;
      height:178px;
      overflow-y: auto;
      border:1px solid $gray-5;
      border-radius: 3px;
      ul {
        padding: 0;
        li {
          padding-bottom:5px;
          list-style: none;
          p {
            margin:0;
            padding:8px 10px 7px 10px;
            background: $gray-2;
            border-radius: 3px;
            cursor: pointer;
            transition: background .28s cubic-bezier(.4,0,.2,1);
            strong {
              display:inline-block;
              min-width:100px;
              color:$pb-6;
              font-weight:500;
            }
            span {
              color:$gray-8;
            }
          }
          &:hover {
            p {
              background: $gray-3;
            }
          }
        }
      }
      .notTicket {
        padding-top:60px;
        text-align:center;
        color: $gray-6;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/layout/merge_ticket_dialog.vue